import './FiSelectPanelMirrorDialog.scss';
import * as angular from 'angular';
import { Component } from '../Component';
import { FiFurnitureService } from '../fiFurniture/FiFurnitureService';


@Component({
    controllerAs: 'vm',
    template: require('./FiSelectPanelMirrorDialog.html'),
    bindings: {
        //
    },
})
export class FiSelectPanelMirrorDialog {
    static $inject = [
        '$mdDialog',
        'fiFurnitureService',
        '$http',
    ];

    constructor(
        private $mdDialog: angular.material.IDialogService,
        private fs: FiFurnitureService,
        private $http: angular.IHttpService,
    ) {
        //
    }

    mirrors_items = [];
    mirrors_results = [];

    $onInit() {
        // mirrors
        this.$http.get('https://www.fitit.lt/db/mirrors.php').then((data) => {
            this.mirrors_items.push(data.data);
            this.mirrors_results = this.mirrors_items[0];
        
            // console.log(this.mirrors_results[0]);
        });

        if (this.fs.furniture.activeRow.mirror_type != 1 && this.fs.furniture.activeRow.mirror_type != 2) {
            this.fs.furniture.activeRow.mirror_type = 0;
        }
        
    }

    close() {
        this.$mdDialog.cancel();
    }


    setFirstMirror() {
        this.fs.furniture.activeRow.mirror = this.mirrors_results[0];
    }

}